import 'css-chunksrc/client/pages/utilityPage/projectModelsPage/styles.scss';export default {
  "toolbar": "_toolbar_15qhu_1",
  "button": "_button_15qhu_7",
  "icon": "_icon_15qhu_27",
  "iconBox": "_iconBox_15qhu_35",
  "main": "_main_15qhu_44",
  "models": "_models_15qhu_48",
  "model": "_model_15qhu_48"
};